// extracted by mini-css-extract-plugin
module.exports = {"ecPreFooter":"PreFooter_ecPreFooter__TLLyl","hideBorder":"PreFooter_hideBorder__ghwR_","showScale":"PreFooter_showScale__PBUm9"};